import { mapMutations, mapGetters } from 'vuex'

export default {
  data () {
    return {
      userId: null,
      clinic_id: null,
      chatId: null
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      scheduleById: 'schedule/byId',
      caseById: 'pcase/byId',
      userById: 'user/byId',
      clinicById: 'clinic/byId',
      chatByDoctor: 'chat/ByDoctor',
      chatByClinic: 'chat/ByClinic',
      chatById: 'chat/byId'
    })
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setUser: 'user/set',
      setClinic: 'clinic/set',
      setChat: 'chat/set'
    }),
    async fetchChats (callback, limit, offset, type) {
      if (!limit) {
        limit = 1000
      }
      if (!offset) {
        offset = 0
      }
      try {
        const params = { limit: limit, offset: offset, type: type }
        const response = await this.axios.get('/api/chat-spaces', { params })
        const chats = response.data.data
        for (const chat of chats) {
          this.setChat({
            chat_space: chat.chat_space,
            id: chat.id,
            last_message: chat.last_message,
            last_seen: chat.last_seen,
            type: chat.type
          })
        }
        callback(chats)
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchUser (id, callback) {
      if (!id) return
      const user = this.userById(id)
      if (user) {
        callback(user)
        return
      }
      if (this.userId === id) {
        setTimeout(() => {
          this.fetchUser(id, callback)
        }, 100)
        return
      }
      this.userId = id
      try {
        const response = await this.axios.get(`/api/users/${id}`)
        if (response.data.data) {
          const user = response.data.data
          const userret = {
            id: user.id,
            name: `${user.firstname.ka} ${user.lastname.ka}`,
            avatar: user.photo
          }
          this.setUser(userret)
          callback(userret)
        }
      } catch (err) {
        this.setError(err)
      }
      this.userId = null
    },
    async fetchUsers (ids, callback) {
      if (!ids) return
      // for (const id of ids) {
      //   this.setUser({ id: id })
      // }
      try {
        const params = { ids: ids }
        const response = await this.axios.post('/api/users', params)
        if (response.data.data && response.data.data.length > 0) {
          for (const user of response.data.data) {
            this.setUser({
              id: user.id,
              name: `${user.firstname[this.authLocale]} ${
                user.lastname[this.authLocale]
              }`,
              avatar: user.photo
            })
          }
          callback(response.data.data)
        }
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchClinic (id, callback) {
      if (!id) return
      const clinic = this.clinicById(id)
      if (clinic) {
        callback(clinic)
        return
      }
      if (this.clinic_id === id) {
        setTimeout(() => {
          this.fetchUser(id, callback)
        }, 100)
        return
      }
      this.clinic_id = id
      try {
        const response = await this.axios.get(`/api/clinics/${id}`)
        const clinic = response.data.data
        const ret = {
          id: clinic.id,
          partner: clinic.is_partner,
          logo: clinic.logo,
          name: clinic.name[this.authLocale],
          city_id: clinic.city_id,
          address: clinic.address[this.authLocale],
          phones: clinic.phones,
          services: clinic.services,
          website: clinic.website,
          email: clinic.email,
          facebook: clinic.facebook,
          description: clinic.description[this.authLocale]
        }
        this.setClinic(ret)
        callback(ret)
      } catch (err) {
        this.setError(err)
      }
      this.clinic_id = null
    },
    async fetchCase (id, callback) {
      if (!id) {
        return
      }
      const pcase = this.caseById(id)
      if (pcase) {
        callback(pcase)
        return
      }
      try {
        const response = await this.axios.get(`/api/patient-cases/${id}`)
        const fetchedPCase = {
          id: response.data.data.id,
          schedule_id: response.data.data.schedule_id,
          schedule: response.data.data.schedule,
          patient_id: response.data.data.patient_id,
          clinic_service_id: response.data.data.clinic_service_id,
          clinic_id: response.data.data.clinic_id,
          service_id: response.data.data.service_id,
          is_personal: response.data.data.is_personal,
          template: response.data.data.template,
          category_id: response.data.data.category_id,
          assignee_id: response.data.data.assignee_id,
          start_time: response.data.data.start_time,
          status: response.data.data.status,
          comment: response.data.data.comment,
          conclusion: response.data.data.conclusion,
          evidences: response.data.data.evidences,
          labtests: response.data.data.labtests,
          files: response.data.data.files,
          diagnoses: response.data.data.diagnoses,
          treatments: response.data.data.treatments,
          created_at: response.data.data.created_at,
          created_by: response.data.data.created_by
        }
        callback(fetchedPCase)
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchDiagnosis (id, callback) {
      if (!id) {
        return
      }
      try {
        const response = await this.axios.get(`/api/diagnoses/${id}`)
        callback(response.data.data)
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchTreatment (id, callback) {
      if (!id) {
        return
      }
      try {
        const response = await this.axios.get(`/api/treatments/${id}`)
        callback(response.data.data)
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchInterview (id, callback) {
      if (!id) return
      try {
        const response = await this.axios.get(`/api/interviews/${id}`)
        callback(response.data.data)
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchChat (id, callback) {
      const chat = this.chatById(id)
      if (chat) {
        callback(chat)
        return
      }
      try {
        const response = await this.axios.get(`/api/chat-spaces/${id}`)
        const chat = response.data.data
        const ret = {
          chat_space: chat.chat_space,
          id: chat.id,
          last_message: chat.last_message,
          last_seen: chat.last_seen,
          type: chat.type
        }
        this.setChat(ret)
        callback(ret)
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchChatByDoctor (id, callback) {
      const chat = this.chatByDoctor(id)
      if (chat) {
        callback(chat)
        return
      }
      try {
        const response = await this.axios.get(
          `/api/chat-spaces/by-doctor/${id}`
        )
        const chat = response.data.data
        if (chat) {
          const ret = {
            chat_space: chat.chat_space,
            id: chat.id,
            last_message: chat.last_message,
            last_seen: chat.last_seen,
            type: chat.type
          }
          this.setChat(ret)
          callback(ret)
        }
        callback(null)
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchChatByClinic (id, callback) {
      const chat = this.chatByClinic(id)
      if (chat) {
        callback(chat)
        return
      }
      try {
        const response = await this.axios.get(
          `/api/chat-spaces/by-clinic/${id}`
        )
        const chat = response.data.data
        const ret = {
          chat_space: chat.chat_space,
          id: chat.id,
          last_message: chat.last_message,
          last_seen: chat.last_seen,
          type: chat.type
        }
        this.setChat(ret)
        callback(ret)
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchSchedule (id, callback) {
      if (!id) {
        return
      }
      const schedule = this.scheduleById(id)
      if (schedule) {
        callback(schedule)
        return
      }
      try {
        const response = await this.axios.get(`/api/schedules/${id}`)
        const fetchedSchedule = {
          id: response.data.data.id,
          patient_id: response.data.data.patient_id,
          patient: response.data.data.patient,
          clinic_service_id: response.data.data.clinic_service_id,
          clinic_id: response.data.data.clinic_id,
          service_id: response.data.data.service_id,
          assignee_id: response.data.data.assignee_id,
          assignee: response.data.data.assignee,
          communication_days: response.data.data.communication_days,
          start_time: response.data.data.start_time,
          status: response.data.data.status,
          price: response.data.data.price,
          interview_id: response.data.data.interview_id,
          interview_status: response.data.data.interview_status,
          patient_case_id: response.data.data.patient_case_id,
          created_at: response.data.data.created_at,
          created_by: response.data.data.created_by
        }
        callback(fetchedSchedule)
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
